// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhl_wv bhl_iz bhl_xj bhl_i bhl_j bhl_q bhl_vr bhl_er bhl_sm bhl_sn bhl_eb","CommentsButton__icon":"il_b bhl_rx"};